import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("VCA", "VEHICULAR COMBAT ARENA", "img/projects/VCA_Project.gif", `
    <center>
        <div class="paragraph center limited-width less-top-margin">
            <strong>RELEASE DATE</strong>: APR 2025 
        </div>
        <div class="paragraph left limited-width">
            <strong>DEVELOPMENT TEAM:</strong> solo project
        </div>        
        <div class="paragraph left limited-width less-top-margin">
            <strong>UE Marketplace (Fab) assets adapted and used:</strong>
            <ul style="margin-top: 0px; margin-bottom: 5px;">
                <li>Modular Low Poly Robots</li>
                <li>Tokyo Stylized Environment</li>
            </ul>
            <strong>Music</strong> by Donarasi.            
        </div>
        <div class="paragraph left limited-width">
            <strong>DEVELOPMENT TIME:</strong> 14 months
        </div>
        <div class="paragraph left limited-width">
            <strong>DESCRIPTION:</strong> Single player game where you drive a configurable vehicle and participate in Arena style battles against AI enemies.
        </div>
    </center>

    <div><br></div>

    <div class="center"> 
        <div class="label">Unreal Engine 5</div>    
        <div class="label">C++</div>
        <div class="label">Blueprints</div>        
        <div class="label">Behavior Tree</div>
        <div class="label">EQS</div>
        <div class="label">CommonUI</div>
        <div class="label">UMG</div>
        <div class="label">Niagara</div>
    </div>

    <div><br></div>
    
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/S40TaJwkZqU" frameborder="0" allowfullscreen></iframe>
    </div>
   
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/zGbdvoWXcGk" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph center">
        <strong>MAIN FEATURES</strong>
    </div>

    <div class="paragraph">
        <center>
            <table>
                <tr>
                    <th style="min-width: 350px; background-color: #B45F40;">
                        VEHICLES
                    </th>
                    <th style="min-width: 350px; background-color: #B45F40;">
                        GAMEPLAY ELEMENTS
                    </th>                    
                </tr>
                <tr>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Vehicle Configuration</li>
                            <li>Vehicle stats</li>
                            <li>Combat</li>
                        </ul>                        
                        <p><center><a href="/#/vca-vehicles" class="header-link">Info & Videos</a></center></p>
                    </td>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Data Points</li>
                            <li>Ammo & health pickups</li>
                            <li>Gears (currency)</li>
                        </ul>
                        <p><center><a href="/#/vca-gameplay" class="header-link">Info & Videos</a></center></p>
                    </td>
                </tr>
                <tr>
                    <th style="min-width: 350px; background-color: #B45F40;">
                        ENEMY AI
                    </th>
                    <th style="min-width: 350px; background-color: #B45F40;">
                        INTERNALS
                    </th>
                </tr>
                <tr>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Navigation system</li>
                            <li>Perception system</li>
                            <li>Behavior Trees</li>
                            <li>State Machines</li>
                            <li>EQS</li>
                        </ul>
                        <p><center><a href="/#/vca-enemy-ai" class="header-link">Info & Videos</a></center></p>
                    </td>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Subsystems</li>
                            <li>Music and Audio</li>
                            <li>Save system</li>
                            <li>Performance</li>
                        </ul>
                        <p><center><a href="/#/vca-internals" class="header-link">Info & Videos</a></center></p>
                    </td>
                </tr>
                <tr>
                    <th style="min-width: 350px; background-color: #B45F40;">
                        USER EXPERIENCE
                    </th>                    
                    <th style="min-width: 350px; background-color: #B45F40;">
                        OTHER
                    </th>
                </tr>
                <tr>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Enhanced input</li>
                            <li>User Interface</li>
                        </ul>
                        <p><center><a href="/#/vca-ux" class="header-link">Info & Videos</a></center></p>
                    </td>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Settings</li>
                            <li>Training Ground</li>
                            <li>Gamedev process</li>
                        </ul>
                        <p><center><a href="/#/vca-other" class="header-link">Info & Videos</a></center></p>
                    </td>
                </tr>
            </table>
        </center>
    </div>
    
    <div class="paragraph center">
        <strong>DOWNLOAD</strong>
    </div>

    <div class="paragraph center">        
        <iframe frameborder="0" src="https://itch.io/embed/3254761?border_width=2&amp;bg_color=282828&amp;fg_color=ffffff&amp;link_color=b45f40&amp;border_color=333333" width="554" height="169"><a href="https://zoldargames.itch.io/vehicular-combat-arena">VEHICULAR COMBAT ARENA by Zoldar Games</a></iframe>
    </div>
    `, "#B45F40", true, true),
    new ProjectData("RetroA", "RETRO ARCADE", "img/projects/RA_Project.gif", `
    <center>
        <div class="paragraph center limited-width less-top-margin">
            <strong>RELEASE DATE</strong>: MAY 2024 
        </div>
        <div class="paragraph left limited-width">
            <strong>DEVELOPMENT TEAM:</strong> solo project
        </div>
        <div class="paragraph left limited-width less-top-margin">
            <strong>Base assets by </strong><a href="https://pixel-carvel.itch.io" class="header-link">Pixel-Carvel</a>
        </div>
        <div class="paragraph left limited-width less-top-margin">
            <strong>Music by </strong> <a href="https://jonathan-so.itch.io" class="header-link">Jonathan So</a>
        </div>
        <div class="paragraph left limited-width">
            <strong>DEVELOPMENT TIME:</strong> 1 month
        </div>
        <div class="paragraph left limited-width">
            <strong>DESCRIPTION:</strong> Single player shoot'em up game inspired in the likes of Capcom's 1942, where you fight waves of enemies, avoid asteroids and challenge powerful bosses.
        </div>
    </center>

    <div class="center"> 
        <div class="label">Unreal Engine 5</div>    
        <div class="label">C++</div>
        <div class="label">Blueprints</div>        
        <div class="label">Behavior Tree</div>
        <div class="label">UMG</div>
        <div class="label">Paper2D</div>
    </div>
    
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/HGlUW9EVMII" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph center">
        <strong>MAIN FEATURES</strong>
    </div>

    <div class="paragraph">
        <center>
            <table>
                <tr>
                    <th style="min-width: 350px; background-color: #2b9793;">
                        2D SETUP IN UNREAL
                    </th>
                    <th style="min-width: 350px; background-color: #2b9793;">
                        GAMEPLAY ELEMENTS
                    </th>                    
                </tr>
                <tr>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Level Setup</li>
                            <li>Pawn Configuration</li>
                        </ul>
                        <p><center><a href="/#/ra-2d-setup-in-unreal" class="header-link">Info & Videos</a></center></p>
                    </td>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 70px;">
                            <li>PowerUps</li>
                            <li>Asteroids</li>                            
                        </ul>
                        <p><center><a href="/#/ra-gameplay" class="header-link">Info & Videos</a></center></p>
                    </td>
                </tr>
                <tr>
                    <th style="min-width: 350px; background-color: #2b9793;">
                        ENEMY AI
                    </th>
                    <th style="min-width: 350px; background-color: #2b9793;">
                        INTERNALS
                    </th>
                </tr>
                <tr>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 50px;">
                            <li>Behavior Trees - Enemies</li>                            
                            <li>Behavior Trees - Bosses</li>
                        </ul>
                        <p><center><a href="/#/ra-enemy-ai" class="header-link">Info & Videos</a></center></p>
                    </td>
                    <td style="min-width: 350px; background-color: #282828; line-height: 1em;">
                        <ul style="margin-left: 70px;">
                            <li>Subsystems</li>
                        </ul>
                        <p><center><a href="/#/ra-internals" class="header-link">Info & Videos</a></center></p>
                    </td>
                </tr>
            </table>
        </center>
    </div>

    <div class="paragraph center">
        <strong>DOWNLOAD</strong>
    </div>

    <div class="paragraph center">
        <iframe frameborder="0" src="https://itch.io/embed/2712297?border_width=2&amp;bg_color=282828&amp;fg_color=ffffff&amp;link_color=2b9793&amp;border_color=333333" width="552" height="167"><a href="https://zoldargames.itch.io/retro-arcade">Retro Arcade by Zoldar Games</a></iframe>
    </div>
    `, "#2b9793"),
    new ProjectData("UNTITLED", "UNTITLED PROJECT", "img/projects/WIP.png", `
    <center>
        <div class="paragraph center limited-width less-top-margin">
            <strong>RELEASE DATE</strong>: In Pre-production
        </div>
        <div class="paragraph left limited-width">
            <strong>DEVELOPMENT TEAM:</strong> solo project
        </div>        
        <div class="paragraph left limited-width">
            <strong>DEVELOPMENT TIME:</strong> WIP
        </div>
        <div class="paragraph left limited-width">
            <strong>DESCRIPTION:</strong> On rails spaceship shooter.
        </div>
    </center>    

    <div class="center"> 
        <div class="label">Unreal Engine 5</div>    
        <div class="label">C++</div>
        <div class="label">Blueprints</div>        
    </div>

    <div class="paragraph center">
        <strong>MAIN FEATURES</strong>
    </div>

    <div class="paragraph center">
        Coming soon!
    </div>
    `, "#00825A")
];